import {withStyles} from '@mui/styles'
import Tooltip from "@mui/material/Tooltip"
import classnames from 'classnames'
import React, {PropsWithChildren} from 'react'
import './FormInputBorder.css'
import {SerializedStyles} from '@emotion/react'

const ErrorTooltip = withStyles({
	tooltip: {
		background: '#aa1200',
		color: '#ffffff',
		fontSize: '14px',
		margin: '2px 0',
		whiteSpace: 'pre-line',
	},
})(Tooltip);

interface FormInputBorderProps extends PropsWithChildren<{}> {
	validationResult?: string[]
	label?: string
	cssLabel?: SerializedStyles
	cssErrorBorder?: SerializedStyles
	afterLabel?: React.ReactNode
	required?: boolean
	inline?: boolean
}

export const FormInputBorder = React.memo(({validationResult, label, cssLabel, cssErrorBorder, afterLabel, required, inline = false, children}: FormInputBorderProps) => (
	<ErrorTooltip disableInteractive disableFocusListener enterDelay={0} placement={'top'} title={validationResult?.join('\n') || ''}>
		<div className={classnames('FormInputBorder', {FormInputBorderInline: inline})}>
			<div css={cssErrorBorder} className={classnames('FormInputErrors', {'hasErrors': validationResult?.length})}>
				{inline && children}
				{(label || afterLabel) &&
					<div css={cssLabel} className={classnames("FormInputLabel unselectableText")}>
						{label && <div dangerouslySetInnerHTML={{__html: label + (required && '&nbsp;*' || '')}}/>}
						{afterLabel}
					</div>
				}
				{!inline && children}
			</div>
		</div>
	</ErrorTooltip>
));
